import { Component, OnDestroy } from '@angular/core';
import { UserControlService } from 'src/app/air/modules/common/service/userControl/user-control.service';
import { CommonService } from 'src/app/air/modules/common/service/common/common.service';
import { AirAppRoutes } from "src/app/air/modules/common/lib/air-api-constant";
import { SubSink } from 'subsink';

@Component({
    selector: 'app-association',
    templateUrl: './app.association.component.html',
    standalone: false
})
export class AppAssociationComponent implements OnDestroy {
  private subscription = new SubSink();
  constructor(
    private userControlService: UserControlService,
    private commonService: CommonService
  ) {

    this.subscription.add(this.userControlService.$userCompany.subscribe((companies: any) => {
      if (companies && companies.length) {
        this.commonService.navigateRoute({
          route: AirAppRoutes.User.HOME,
          type: 'User'
        });
      }
    }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
